import React, { useState, useEffect } from 'react'
import { loadAwsFile } from './../../../utils/aws.util'
import { useOrganizationContext } from './../../../context/organization.context'
import { Card } from '../../globalComponents/card'

export default function OrgCard({ cardInfo, onSelect, index }) {
	const [orgImage, setOrgImage] = useState(null)
	const {
		state: { orgsColor },
	} = useOrganizationContext()

	useEffect(() => {
		if (!!cardInfo?.organization_image_path) {
			loadAwsFile(cardInfo.organization_image_path, d => {
				let image = null
				image = 'data:' + d.type + ';base64,' + d.data
				setOrgImage(image)
			})
		}
	}, [cardInfo])

	if (!cardInfo) return <></>

	return (
		<>
			<Card
				cardType='floatingOrgCard'
				onClick={onSelect}
				NoofNotifications=''
				cardColor={orgsColor?.[cardInfo.organization_id]}
				imgSrc={orgImage}
				OrgName={cardInfo.organization_name}
				empDesignation={cardInfo.asset_type_name}
				index={index}
				onClickProps={cardInfo}
			/>
		</>
	)
}
